import { render, staticRenderFns } from "./InputInboxSubmission.vue?vue&type=template&id=8b039752&"
import script from "./InputInboxSubmission.vue?vue&type=script&lang=js&"
export * from "./InputInboxSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports